
import React from 'react';
import BottomNav from '../../components/BottomNav';
import { useMobileStyles } from '../../styles/muiStyles';
import MobileMessages from '../Message/MobileMessages';
import VirtualRoom from '../Virtual Meeting/VirtualRoom';

import { useLocation } from "react-router-dom";


const MobileMain = () => {
  const classes = useMobileStyles();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  return (
    <div className= {classes.root} >
      <div>
        {splitLocation[1] === "messages" ? <MobileMessages />: <VirtualRoom/>}
      </div>
      <BottomNav/>
    </div>
  );
};

export default MobileMain;
